export default {
	PROFILE: 'Profile',
};
